import { Center, Image, Spinner, VStack } from '@chakra-ui/react';

import CBPLogo from 'view-layer/assets/cb-payment-logo.png';

export const Loader = () => {
  return (
    <Center w="100%" h="100vh">
      <VStack
        spacing={8}
      >
      <Image w="200px" src={CBPLogo} alt="Loading..." />
      <Spinner
        thickness="4px"
        emptyColor="gray.200"
        color="blue.500"
        size="lg"
      />
      </VStack>
    </Center>
  );
}
